import { selectSelfProvider } from '@modules/auth/auth.Dux'
import React, { Component } from 'react'
import connect from 'react-redux/es/connect/connect'
import Select from 'react-select-legacy'
import Consultations from '@services/Consultations'
import './MultiSelect.scss'

class AsyncProfessionalField extends Component {
  static defaultProps = {
    defaultSelectAll: false,
    meta: {},
    input: {
      value: null,
      onChange: () => null,
    },
    labelKey: 'name',
    valueKey: 'id',
  }

  state = {
    options: [],
    loading: true,
  }

  //TODO: add provider restrictions once merged into PAAS
  fetchProfessionals = (text) => {
    return Consultations.professional
      .index({ page: 1, limit: 7, search: text })
      .then((response) => this.setState({ options: response.data, loading: false }))
  }

  render() {
    const { label } = this.props
    const disabledClass = this.state.loading && 'disabled'
    return (
      <div className="md-select-basic">
        {label && <label>{`${label}`}</label>}
        <div className={`md-multi-select ${disabledClass}`}>
          <Select.Async
            labelKey={this.props.labelKey}
            valueKey={this.props.valueKey}
            placeholder="Profesional"
            value={this.props.input.value}
            loadOptions={this.fetchProfessionals}
            onChange={this.props.input.onChange}
            removeSelected={false}
            filterOptions={(options) => this.state.options} // do not apply filters as they are already applied on backend
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  selfProvider: selectSelfProvider(state),
})
export default connect(mapStateToProps)(AsyncProfessionalField)
